<template>
  <div>
    <div v-for="(article, iArticle) in articlesParProduit(articles)" :key="'article' + iArticle" :id="'accordion' + iArticle" :style="verrouille ? 'opacity:.7' : ''">
      <div class="card">
        <div class="card-header flex-center-space-between">
          {{nomArticle(article.nom)}}
          <div class="flex-end">
            <span :v-tooltip="'Mieux-disant'" :class="['pl-3 pr-3 pt-1 pb-1', { 'meilleurPrixProduitAgap': totalPcbMinimal(article.produits) == mieuxDisantGeneral }]">{{ totalPcbMinimal(article.produits) | afficherPrix }}</span>
            <div v-if="articleOrigine" class="flex-center-space-between">
              <span class="ml-5">
                <i :class="[{'fas text-warning':articleGlobalEnFavori(article.produitId)},{'far':!articleGlobalEnFavori(article.produitId)},{'fa-spin':isLoading(article)}]" class="fa-star cursor-pointer" @click="setArticleFavori(article)"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="card-container">
          <div class="card card-minimal">
            <table class="table table-sm table-borderless text-center">
              <colgroup>
                <col>
                <col width="30">
                <col width="75">
                <col width="160">
                <col width="100">
                <col width="90">
                <col width="90">
                <col width="40">
              </colgroup>
              <thead>
                <th class="aligner-gauche">Désignation</th>
                <th>FT</th>
                <th>Réf.</th>
                <th>Fournisseur</th>
                <th>PCB</th>
                <th>PU HT</th>
                <th>Total HT</th>
                <th></th>
              </thead>
            </table>
            <hr class="mt-0 mb-0" />
            <div class="table-body">
              <table class="table table-sm table-borderless text-center">
                <colgroup>
                  <col>
                  <col width="30">
                  <col width="75">
                  <col width="160">
                  <col width="100">
                  <col width="90">
                  <col width="90">
                  <col width="40">
                </colgroup>
                <tbody>
                  <tr v-for="(ligneArticle, iLigne) in article.produits" :key="'article' + iLigne" :class="[{ 'ligne-desactivee': ligneArticle.bloque }, 
                      {'ligne-origine-selectionnee':estArticleOrigine(article, ligneArticle)}, {'ligne-selectionnee': articleEstSelectionne(article, ligneArticle) }]"
                      @click="selectionnerLigne(article, ligneArticle)">
                    <td class="aligner-gauche">{{ ligneArticle.designation }} - {{ ligneArticle.marque }}</td>
                    <td><BoutonFicheTechnique v-if="ligneArticle.urlFT" size="sm" :fournisseurId="ligneArticle.fournisseurId" :reference="ligneArticle.reference" :urlFT="ligneArticle.urlFT" /></td>
                    <td>{{ ligneArticle.reference }}</td>
                    <td>{{ fournisseurNom(ligneArticle.fournisseurId) }}</td>
                    <td>{{ ligneArticle.pcb }} {{ abregerTexte(ligneArticle.uc, 10) }}</td>
                    <td>
                      <span :class="['pl-2 pr-2 pt-1 pb-1', { 'meilleurPrixArticleFournisseur': prixMinimal(article.produits) == ligneArticle.prixUnitaire }]">
                        {{ ligneArticle.prixUnitaire | afficherPrix }}
                      </span>
                    </td>
                    <td>
                      <span :class="['pl-2 pr-2 pt-1 pb-1', { 'meilleurPrixArticleFournisseur': totalPcbMinimal(article.produits) == totalPcb((articleOrigine && articleOrigine.quantiteBesoinEnUC) || 0, ligneArticle.pcb, ligneArticle.prixUnitaire) }]">
                        {{ totalPcb((articleOrigine && articleOrigine.quantiteBesoinEnUC) || 0, ligneArticle.pcb, ligneArticle.prixUnitaire) | afficherPrix }}
                      </span>
                    </td>
                    <td>
                      <i :class="[{'fas text-warning':articleEnFavori(article.produitId, ligneArticle.fournisseurId)},{'far':!articleEnFavori(article.produitId, ligneArticle.fournisseurId)},{'fa-spin':isLoading(article, ligneArticle)}]" class="fa-star" @click="setArticleFavori(article, ligneArticle)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoutonFicheTechnique from '@/components/Divers/BoutonFicheTechnique'
import { connecteData } from "@/mixins/connecteData"
import { modifierFavori } from '@/api/gpao/produits'
import { fournisseurs } from '@/mixins/fournisseurs'
import { showAlerts } from '@/mixins/alerts'
import { qtePCB, abregerTexte } from '@/helpers/utils'
import { mapGetters } from "vuex"

export default {
  name: "ArticlesParProduit",
  props: {
    articles: Object,
    favoris: Array,
    articleOrigine: Object,
    disabled: Boolean
  },
  mixins: [fournisseurs, connecteData, showAlerts],
  components: { BoutonFicheTechnique },
  data() {
    return {
      articleChoisi: {
        produitId: '',
        fournisseurId: ''
      },
      favorisLoading: [],
      favorisChoisis: []
    }
  },
  computed: {
    ...mapGetters("auth", ["isAdmin"]),
    verrouille() {
      return this.disabled
    },
    mieuxDisantGeneral() {
      return Math.min(...Object.keys(this.articles).map(idProduit => this.totalPcbMinimal(this.articles[idProduit] || [])))
    }
  },
  watch: {
    favoris() {
      this.favorisChoisis = this.favoris
    }
  },
  methods: {
    prixMinimal(produits) {
      return (produits.reduce((min, p) => p.prixUnitaire < min ? p.prixUnitaire : min, produits[0].prixUnitaire));
    },
    totalPcbMinimal(produits) {
      return produits.reduce((min, p) => this.totalPcb(this.articleOrigine?.quantiteBesoinEnUC ?? 0, p.pcb, p.prixUnitaire) < min ? this.totalPcb(this.articleOrigine?.quantiteBesoinEnUC ?? 0, p.pcb, p.prixUnitaire) : min, this.totalPcb(this.articleOrigine?.quantiteBesoinEnUC ?? 0, produits[0].pcb, produits[0].prixUnitaire))
    },
    articleGlobalEnFavori(produitId) {
      return Boolean(this.favorisChoisis.find(el => el.produitId === produitId && !el.fournisseurId && !el.recetteId))
    },
    articleEnFavori(produitId, fournisseurId) {
      return Boolean(this.favorisChoisis.find(el => el.produitId === produitId && el.fournisseurId === fournisseurId && !el.recetteId))
    },
    articleChoisiEnFavori() {
      // L'article choisi est considéré comme favori si l'article est favori ou si le produit correspondant est favori
      return this.articleGlobalEnFavori(this.articleChoisi.produitId) || this.articleEnFavori(this.articleChoisi.produitId, this.articleChoisi.fournisseurId)
    },
    favoriModifiable(produitId, fournisseurId) {
      let favoris = this.favorisChoisis.filter(el => el.produitId === produitId && !el.recetteId)
      if (fournisseurId)
        favoris = favoris.filter(el => el.fournisseurId === fournisseurId)
      else
        favoris = favoris.filter(el => !el.fournisseurId)
      return Boolean(!favoris.find(el => el.lectureSeule))
    },
    nomArticle(id) {
      var retour = this.$store.state.produits?.produitsUtilisateur?.find(el => el.id === id)?.designation
      if (this.profilIsAdmin) {
        retour = retour + "   - " + id
      }
      return retour;
    },
    abregerTexte(texte, longueur) {
      return abregerTexte(texte, longueur)
    },
    qtePcb(qte, pcb) {
      return qtePCB(qte, pcb)
    },
    totalPcb(qte, pcb, pu) {
      return (qtePCB(qte, pcb) || pcb) * pu
    },
    articlesParProduit(articles) {
      var retour = articles && Object.entries(articles).map(el => { return { nom: el[0], produits: el[1], produitId: el[0] } })
      return retour || [];
    },
    async setArticleFavori(article, ligneArticle) {
      let fournisseurId = ligneArticle?.fournisseurId || null
      if (this.verrouille || ligneArticle?.bloque || !this.favoriModifiable(article.produitId, fournisseurId))
        return
      
      this.favorisLoading.push({ produitId: article.produitId, fournisseurId: fournisseurId })
      let newState = await modifierFavori(this.etabCourantId, article.produitId, fournisseurId)
      this.favorisLoading = this.favorisLoading.filter(l => l.produitId !== article.produitId || l.fournisseurId !== fournisseurId)

      if (newState.data) {
        this.favorisChoisis.push({ produitId: article.produitId, fournisseurId: fournisseurId, lectureSeule: false })
      } else {
        this.favorisChoisis = this.favorisChoisis.filter(f => f.produitId !== article.produitId || f.fournisseurId !== fournisseurId)
      }

      this.$emit("toggle-favori", { produitId: article.produitId, fournisseurId: fournisseurId, estFavori: Boolean(newState.data) })

      this.$toast('Favori modifié !', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        className: ['toast-success'],
        duration: 1500
      })
    },
    isLoading(article, ligneArticle) {
      let fournisseurId = ligneArticle?.fournisseurId
      let fl = this.favorisLoading.filter(l => l.produitId === article.produitId)
      if (fournisseurId && fl.length)
        return fl.find(l => l.fournisseurId === fournisseurId)
      return fl.find(l => !l.fournisseurId)
    },
    selectionArticle(produit) {
      this.articleChoisi.produitId = produit.produitId
      this.articleChoisi.fournisseurId = produit.fournisseurId

      this.$emit('selection-article', produit)
    },
    validationArticle(produit) {
      this.$emit('validation-article', produit)
    },
    articleEstSelectionne(article, ligneArticle) {
      return this.articleChoisi.produitId === article.produitId && (this.articleChoisi.fournisseurId || null) === (ligneArticle?.fournisseurId || null)
    },
    estArticleOrigine(article, ligneArticle) {
      if (!this.articleOrigine)
        return false
      return this.articleOrigine.produitId === article.produitId && (this.articleOrigine.fournisseurId || null) === (ligneArticle?.fournisseurId || null)
    },
    selectionnerLigne(article, ligneArticle) {
      if (this.verrouille || ligneArticle.bloque)
        return

      let produit = ligneArticle
      produit.produitId = article.produitId

      if (this.articleEstSelectionne(article, ligneArticle)) {
        this.validationArticle(produit)
      } else {
        this.selectionArticle(produit)
      }
    }
  },
  mounted() {
    this.favorisChoisis = this.favoris

    this.articleChoisi.produitId = this.articleOrigine.produitId
    this.articleChoisi.fournisseurId = this.articleOrigine.fournisseurId
  }
}
</script>
